import Joi from 'joi';
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
import * as Validator from "./Ticket.Validator";

class TicketAPI {
  create = async (data) => {
    const validator = Validator.VALIDATION_TICKER_CREATE;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/tickets/create", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  update = async (data) => {
    const validator = Validator.VALIDATION_TICKER_UPDATE;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/tickets/update", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  detail = async (data) => {
    const validator = Validator.VALIDATION_TICKER_UPDATE;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.get(HOST + `/tickets/detail/${data.id}`, data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  delete = async (data) => {
    const validator = Validator.VALIDATION_TICKER_DELETE;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/tickets/delete", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  updateClaim = async (data) => {
    const validator = Validator.VALIDATION_TICKER_UPDATE;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/tickets/updateClaim", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  adminList = async (data) => {
    const validator = Validator.VALIDATION_TICKER_ADMIN_LIST;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/tickets/adminList", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };
}

export default new TicketAPI();



// WEBPACK FOOTER //
// ./src/services/ticket/Ticket.API.js